// src/ui/CategoryBadge.jsx
import React from "react";

export default function CategoryBadge({ children }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-gray-300 px-2.5 py-1 text-xs uppercase tracking-wide text-gray-700">
      {children}
    </span>
  );
}
